import { CMS_API_ENDPOINT } from "../constants/api-constants";

const CMS_BASE_URL = CMS_API_ENDPOINT.replace("/api", "");

export function toMediaUrl(media: any): string {
    return media?.url ? `${CMS_BASE_URL}${media.url}` : "";
}
